let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7w8WE")).then(() => parcelRequire('dXAEg'));